// The static parts of a text entry, as TextEditor's defaultTextObject and the texts a design
// stores carry them: the custom styles, the active states and the colour-list references of a
// new text, and every setting the editor applies across a selection. The font values and the
// position depend on the loaded fonts and the selection, so they stay in TextEditor.
export const defaultHighlight = {
  color: '#ffff00',
  mode: 'standard',
};
export const defaultUnderline = {
  color: '#000000',
  thickness: 0.5,
  yOffset: 0.5,
  widthAdjustment: 0,
  lineStyle: 'solid',
  lineCap: 'butt',
  gapLength: 2,
  dashLength: 4,
};
export const defaultStrikethrough = {
  color: '#000000',
  thickness: 0.5,
  yOffset: 0,
  widthAdjustment: 0,
  lineStyle: 'solid',
  lineCap: 'butt',
  gapLength: 2,
  dashLength: 4,
};
export const defaultIsActiveStates = {
  fill: false,
  highlight: false,
  underline: false,
  strikethrough: false,
  stroke: false,
  textSpacing: false,
};
export const defaultSelectedTextColorIndexes = {
  fill: null,
  highlight: null,
  underline: null,
  strikethrough: null,
  stroke: null,
};

export const TEXT_FIELD_PATHS = [
  'fontFamilyName',
  'style.fontFamily',
  'style.fontSize',
  'style.fill',
  'style.strokeWidth',
  'style.stroke',
  'style.letterSpacing',
  'style.wordSpacing',
  'style.fontWeight',
  'style.fontStretch',
  'style.fontStyle',
  'customStyles.highlight.color',
  'customStyles.highlight.mode',
  'customStyles.underline.color',
  'customStyles.underline.thickness',
  'customStyles.underline.yOffset',
  'customStyles.underline.widthAdjustment',
  'customStyles.underline.lineStyle',
  'customStyles.underline.lineCap',
  'customStyles.underline.gapLength',
  'customStyles.underline.dashLength',
  'customStyles.strikethrough.color',
  'customStyles.strikethrough.thickness',
  'customStyles.strikethrough.yOffset',
  'customStyles.strikethrough.widthAdjustment',
  'customStyles.strikethrough.lineStyle',
  'customStyles.strikethrough.lineCap',
  'customStyles.strikethrough.gapLength',
  'customStyles.strikethrough.dashLength',
  'position.isoSection',
  'position.gridStructure',
  'position.gridRow',
  'position.gridColumn',
  'position.cellAlignment',
  'position.boundingBox',
  'position.rotation',
  'position.xOffset',
  'position.yOffset',
  'isActiveStates.fill',
  'isActiveStates.highlight',
  'isActiveStates.underline',
  'isActiveStates.strikethrough',
  'isActiveStates.stroke',
  'isActiveStates.textSpacing',
  'selectedTextColorIndexes.fill',
  'selectedTextColorIndexes.highlight',
  'selectedTextColorIndexes.underline',
  'selectedTextColorIndexes.strikethrough',
  'selectedTextColorIndexes.stroke',
]; // all possible paths (settings) of a text entry (except the "text" content itself, "tagId" and "visible" settings)
